import { cn } from "@/lib/utils";

const LABELS = { vacant: "Vacant", occupied: "Occupied", maintenance: "Maintenance", needs_cleaning: "Needs Cleaning", management: "Management", reserved: "Reserved" };

export const StatusBadge = ({ status, unitNumber, className }) => {
  const s = status || "vacant";
  return (
    <span
      data-testid={unitNumber ? `unit-status-badge-${unitNumber}` : undefined}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold",
        `status-${s}`,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", `dot-${s}`)} />
      {LABELS[s]}
    </span>
  );
};
